import { get, post } from '@/utils/service';
import { login as loginUserWebSocket } from '@/utils/userWebSocket';

// import { obj2string, toSmallCamel } from '@/utils/url';
// import { i18n } from '@/locales/i18n';

// 全仓杠杆API
export const leverageApi = {
    // 全仓杠杆 开通、开启状态、倍数
    getRiskStatus(params) {
        return get('@siteapi/unified/private/account/agreement/spot_margin/get', { params });
    },
    // 倍数、开通、开启 提交问卷答题
    submitQuestion(params) {
        return post('@siteapi/unified/private/account/agreement/spot_margin/set', params);
    },
    // 查询借贷币种列表
    getTokenList(params) {
        return get('@siteapi/mp/coin-loancoinlist', { params });
    },
    // vip数据
    getVIPInfo(params) {
        return get('@siteapi/mp/platform-vipinfo', { params });
    },
    // 获取折算率
    getDiscount() {
        return get('@siteapi/mp/coin-margincoinlist');
    },
};

export const userapi = {
    // 获取用户统一账户资产
    getUnifiedAsset(params) {
        return post('@siteapi/unified/private/spot-walletbalance', params, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        });
    },
    // 获取钱包资产列表
    getWalletBalance(params) {
        return post('@siteapi/unified/private/account-walletbalance', params);
    },
    // 获取当前订单
    getOrders(params) {
        return post('@unified/spot/v5/order/orders', params);
    },
    // 获取历史订单
    getOrderHistory(params) {
        return post('@unified/spot/v5/order/orderHistory', params);
    },
    // 获取交易记录订单
    getOrderTrades(params) {
        return post('@unified/spot/v5/order/trades', params);
    },
    // 获取借贷-币种列表
    getLiabilityList(params) {
        return post('@unified/v5/queryLiabilityList', params);
    },
};

export const ltApi = {
    // 申购赎回记录
    getLtHistoryRecord(params) {
        return get('@spot/api/lt/v2/record', { params });
    },
};

export const optionapi = {
    // 获取升级统一账户后创新区持仓限额
    getInnovateQuotaUta(params) {
        return get('@siteapi/mp/platform-limit', { params });
    },
    // 获取保证金预警线
    getWarnLine(params) {
        return post('@api2/option/usdc/public/optionmp/query/config/global', params);
    },
};

export const utaTopic = {
    // 保证金模式
    subMarginMode: async (isUTA, callback) => {
        const ws = await loginUserWebSocket({ isUTA });
        return ws.sub({ topic: 'user.service' }, callback);
    },
};
